import React, { useEffect, useRef, useState } from "react";
import { HeaderPage } from "../base/headerPage";
import { MessagesConstant } from "./index.const";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import NewMessage from "./newMessage";
import "./index.scss";
import { getUserCredential } from "src/lib/cookies";
import { getForProvider } from "./service/getForProvider";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { changeMessageCount, setNewMessage } from "src/redux/actions/setting-actions";
// import moment from 'moment'
import moment from "moment-timezone";
import { Loader } from "@progress/kendo-react-indicators";
import { getForApprover } from "./service/getForApprover";
import { getMessages, getUnreadCount } from "./service/getMessages";
import { sendMessage } from "./service/sendMessage";
import { markAsRead } from "./service/markAsRead";
import { uploadFilesSequentially } from "./service/uploadFilesSequentially";
import { selectMobileConfigCode } from "./service/selectMobileConfigCode";
import { updateChatStatus } from "./service/updateChatStatus";
import { generateHeader } from "src/api-setup/api-helper";
import { LoadingPanel } from "src/components/loadingPanel";
import { Window } from "@progress/kendo-react-dialogs";
import { downloadFile } from "./service/downloadFile";
import { socket } from "../../App";
import { toast } from "react-toastify";
import { Button } from "@progress/kendo-react-buttons";

const getQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    conversationId: searchParams.get("conversationId"),
  };
};

const Messages = (pageProps) => {
  const fileInputRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const cookiesData = getUserCredential();
  const dispatch = useDispatch();
  const chatListContainerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const skipNextFetchRef = useRef(false);
  const selectedChatRef = useRef(null);
  const intervalRef = useRef(null);
  const isTabSwitchRef = useRef(false);
  const activeChatRef = useRef(null);
  const isInitialMessagesLoadRef = useRef(true);
  const { userStatusData } = useSelector((state) => state.mobileRoleReducer?.mobileRoleData || {}, shallowEqual);

  const statusTabs = [
    { id: 0, label: "All", count: 10, value: "ALL" },
    { id: 1, label: "Pending", count: 15, value: "PENDING" },
    { id: 2, label: "Resolved", count: 10, value: "RESOLVED" },
  ];
  const headerConfig = {
    title: MessagesConstant.headerConfig.title,
    id: "messages",
    messages: MessagesConstant.messages,
  };
  const [selectedTab, setSelectedTab] = useState(statusTabs[0]);
  const [search, setSearch] = useState("");
  const [inputText, setInputText] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [visible, setVisible] = useState(false);
  const [chatList, setChatList] = useState([]);
  const [filteredChatList, setFilteredChatList] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState([]);
  const [isLoadChat, setIsLoadChat] = useState(false);
  const [fileProgress, setFileProgress] = useState({});
  const [mobileConfigCode, setMobileConfigCode] = useState(null);
  const [isLoadStatus, setIsLoadStatus] = useState(false);
  const [isVisibleCofirmation, setIsVisibleConfirmation] = useState(false);
  const [stageChange, setStateChange] = React.useState("DEFAULT");
  const [modal, setModal] = React.useState(true);
  const [resolvedKey, setResolvedKey] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [directAccessConversationId, setDirectAccessConversationId] = useState(null);
  const [conversationNotFound, setConversationNotFound] = useState(false);

  const handleTabSelect = (tab) => {
    if (tab.value === selectedTab.value) return;
    setSelectedTab(tab);
    isTabSwitchRef.current = true;
  };

  const onSelectChat = (msg) => setSelectedChat(msg);

  const handleAttachClick = () => fileInputRef.current?.click();

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const mappedFiles = files.map((file) => ({
      file,
      original_name: file.name,
      document_size: file.size,
      document_type: file.type,
    }));

    setSelectedDoc((prev) => {
      const combinedFiles = [...prev, ...mappedFiles];
      if (combinedFiles.length > 5) {
        alert("You can upload a maximum of 5 files");
        return prev;
      }
      return combinedFiles;
    });

    e.target.value = "";
  };

  const handleSendMessage = async () => {
    if (inputText.trim().length === 0 && selectedDoc.length === 0) return;

    if (inputText.trim().length > 0 && selectedDoc.length === 0) {
      const tempMessageId = (allMessages.length + 1).toString();
      const newMessage = {
        id: tempMessageId,
        sender_id: cookiesData?.out_user_id,
        sender_name: "You",
        message_text: inputText,
        documents: [],
        sent_at: moment().local().format(),
      };
      setAllMessages((prev) => [...prev, newMessage]);
      setInputText("");

      try {
        await sendMessage(cookiesData, dispatch, selectedChat?.conversation_mstr_key, inputText);
      } catch (err) {
        console.error("Error sending text message:", err);
      }
    }

    if (selectedDoc.length > 0) {
      const filesToSend = selectedDoc.slice(0, 5);

      for (const doc of filesToSend) {
        const tempMessageId = `${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

        const newMessage = {
          id: tempMessageId,
          sender_id: cookiesData?.out_user_id,
          sender_name: "You",
          message_text: inputText.trim(),
          documents: [doc],
          sent_at: moment().local().format(),
        };

        try {
          const sendMsgData = await sendMessage(
            cookiesData,
            dispatch,
            selectedChat?.conversation_mstr_key,
            inputText.trim() // no text
          );

          setAllMessages((prev) => [...prev, newMessage]);
          setInputText("");

          const transactionId = sendMsgData?.out_message_mstr_key;
          const uploadPathHeader = mobileConfigCode?.doc_dir ?? "";

          const uploadDocRes = await uploadFilesSequentially({
            files: [doc.file],
            transactionId,
            uploadPathHeader,
            onProgress: (percent) => {
              setFileProgress((prev) => ({
                ...prev,
                [doc.file.name]: percent,
              }));
            },
          });

          const uploadedDoc = uploadDocRes?.[0]?.row_result?.[0];

          if (uploadedDoc) {
            setAllMessages((prev) =>
              prev.map((msg) => (msg.id === tempMessageId ? { ...msg, documents: [uploadedDoc] } : msg))
            );
          }
        } catch (error) {
          console.error("Error sending file message:", error);
        }
      }

      setSelectedDoc([]);
    }

    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleFileDownload = async (doc) => {
    console.log("DOCUMENT", doc);
    downloadFile(doc, (percentage) => {
      console.log("PERCENTAGE", percentage);
    });
  };

  const getAllMessages = async (showLoader = false) => {
    try {
      if (showLoader) setIsLoadChat(true);

      const [messageList] = await Promise.all([
        getMessages(cookiesData, dispatch, selectedChat?.conversation_mstr_key),
        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);
      // PERTICULAR USER CHAT MESSAGES
      console.log("MESSAGE LIST", messageList);

      setAllMessages(messageList);
      if (showLoader) setIsLoadChat(false);

      const unreadMessages = messageList
        .filter((msg) => String(msg.sender_id) !== String(cookiesData?.out_user_id) && msg.is_seen === 0)
        .map((msg) => ({
          id: msg.message_mstr_key,
          read_at: new Date().toISOString(),
        }));

      if (unreadMessages.length > 0) {
        skipNextFetchRef.current = true;
        handleMarkAsRead(selectedChat, unreadMessages);
      }
    } catch (error) {
      if (showLoader) setIsLoadChat(false);
    }
  };

  const fetchChatList = async () => {
    try {
      setIsLoading(true);
      let chatListResponse = [];
      if (
        userStatusData?.[0]?.pay_request_tracker_read_access === 1
      ) {
        chatListResponse = await getForApprover(cookiesData, dispatch);
      } else {
        chatListResponse = await getForProvider(cookiesData, dispatch);
      }

      const updatedChatList = chatListResponse || [];
      setChatList(updatedChatList);
      setFilteredChatList(updatedChatList);

      const queryParams = getQueryParams();
      if (queryParams.conversationId) {
        const targetChat = updatedChatList.find(
          (chat) => String(chat.conversation_mstr_key) === String(queryParams.conversationId)
        );

        if (targetChat) {
          setSelectedChat(targetChat);
          setConversationNotFound(false);
          setDirectAccessConversationId(queryParams.conversationId);
          setTimeout(() => {
            selectedChatRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 300);
        } else {
          // conversation not found, show error
          setSelectedChat(null);
          setConversationNotFound(true);
          dispatch(
            setNewMessage({
              message: "The conversation you're looking for was not found.",
              type: "Warning",
              show: true,
            })
          );
        }
      } else {
        // No chat selected by default - show welcome state
        setSelectedChat(null);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching chat list:", error);
    }
  };

  const handleChangeStatus = async () => {
    try {
      await Promise.all([
        updateChatStatus(cookiesData, dispatch, selectedChat?.conversation_mstr_key),
        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);

      setChatList((prevList) =>
        prevList.map((chat) =>
          chat.conversation_mstr_key === selectedChat?.conversation_mstr_key
            ? { ...chat, conversation_status: "RESOLVED" }
            : chat
        )
      );

      setFilteredChatList((prevList) =>
        prevList.map((chat) =>
          chat.conversation_mstr_key === selectedChat?.conversation_mstr_key
            ? { ...chat, conversation_status: "RESOLVED" }
            : chat
        )
      );

      setSelectedChat((prev) => (prev ? { ...prev, conversation_status: "RESOLVED" } : prev));
      setTimeout(() => {
        selectedChatRef.current?.scrollIntoView({
          behavior: "smooth",
        });
      }, 300);

      const resolvedChat = filteredChatList.find((c) => c.conversation_mstr_key === resolvedKey);
      if (resolvedChat) {
        setSelectedChat({ ...resolvedChat, conversation_status: "RESOLVED" });
      }
    } catch (error) {
      console.error("Error updating chat status:", error);
    } finally {
      setIsLoadStatus(false);
    }
  };

  const getMobileConfig = async () => {
    try {
      const [selectMobileConfigData] = await Promise.all([
        selectMobileConfigCode(cookiesData, dispatch),
        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);

      setMobileConfigCode(selectMobileConfigData);
    } catch (error) {}
  };

  const handleMarkAsRead = async (chatItem, unreadMessages = []) => {
    try {
      if (unreadMessages.length === 0) return;

      const response = await markAsRead(cookiesData, dispatch, unreadMessages);
      if (response) {
        skipNextFetchRef.current = true;

        setChatList((prev) =>
          prev.map((c) => (c.conversation_mstr_key === chatItem.conversation_mstr_key ? { ...c, unread_count: 0 } : c))
        );

        setFilteredChatList((prev) =>
          prev.map((c) => (c.conversation_mstr_key === chatItem.conversation_mstr_key ? { ...c, unread_count: 0 } : c))
        );

        setSelectedChat((prev) =>
          prev && prev.conversation_mstr_key === chatItem.conversation_mstr_key ? { ...prev, unread_count: 0 } : prev
        );
        // dispatch(changeMessageCount([]));
      }
    } catch (error) {
      console.error("Error marking as read:", error);
    }
  };

  const handleStageChange = (e) => {
    setStateChange(e.state);
    setModal(e.state === "DEFAULT");
  };

  // useEffect(() => {
  //   const userId = cookiesData?.out_user_id;

  //   const registerUserRoom = () => {
  //     if (socket && userId) {
  //       socket.emit("message-register-user", userId);
  //     }
  //   };

  //   console.log("Socket Connection", socket);

  //   if (socket) {
  //     registerUserRoom();
  //     socket.on("connect", registerUserRoom);
  //   }

  //   const onReceiveMessage = (data) => {
  //     console.log("onReceiveMessage", data);

  //     if (data && data.in_message_text) {
  //       const newMessage = {
  //         id: Date.now().toString(),
  //         message_text: data.in_message_text,
  //         sender_id: data.in_user_id,
  //         sent_at: new Date().toISOString(),
  //         is_seen: 0,
  //         documents: []
  //       };
  //       setAllMessages((prev) => [...prev, newMessage]);
  //     } else {
  //       setAPICall(true);
  //     }

  //     // Update sidebar chat list
  //     setChatListAPICall(true);
  //   };

  //   if (socket) {
  //     socket.off("MESSAGE_SENT", onReceiveMessage);
  //     socket.on("MESSAGE_SENT", onReceiveMessage);
  //   }

  //   return () => {
  //     if (socket) {
  //       socket.off("connect", registerUserRoom);
  //       socket.off("MESSAGE_SENT", onReceiveMessage);

  //     }
  //   };
  // }, [dispatch]);

  useEffect(() => {
    const userId = cookiesData?.out_user_id;

    if (!socket || !userId) return;

    const registerUserRoom = () => {
      socket.emit("message-register-user", userId);
    };

    // Initial register
    registerUserRoom();

    // Re-register after reconnect
    socket.on("connect", registerUserRoom);

    const onReceiveMessage = (data) => {
      if (!data?.in_message_text) return;

      /**
       * Ignore own socket message
       */
      if (String(data.in_user_id) === String(cookiesData?.out_user_id)) {
        return;
      }

      /**
       * CHECK ACTIVE CHAT
       */
      const isCurrentChat = String(data.in_conversation_mstr_key) === String(selectedChat?.conversation_mstr_key);

      /**
       * IF CURRENT OPEN CHAT
       * => append message
       */
      if (isCurrentChat) {
        const newMessage = {
          id: Date.now().toString(),
          message_mstr_key: Date.now().toString(),
          sender_id: data.in_user_id,
          sender_name:
            String(data.in_user_id) === String(cookiesData?.out_user_id) ? "You" : selectedChat?.user_name || "User",
          message_text: data.in_message_text,
          sent_at: new Date().toISOString(),
          is_seen: 0,
          documents: [],
        };

        setAllMessages((prev) => {
          /**
           * Prevent duplicate
           */
          const alreadyExists = prev.some(
            (msg) => msg.message_text === newMessage.message_text && msg.sender_id === newMessage.sender_id
          );

          if (alreadyExists) return prev;

          return [...prev, newMessage];
        });

        socket.emit("MESSAGE_SEEN", {
          in_user_id: cookiesData?.out_user_id,
          in_tenant_id: cookiesData?.out_tenant_id,
          in_message_mstr_key: data.message_mstr_key,
        });

        /**
         * SCROLL TO BOTTOM
         */
        setTimeout(() => {
          messagesEndRef.current?.scrollIntoView({
            behavior: "smooth",
          });
        }, 100);
      } else {
        toast.info("You have a new message");
      }

      /**
       * UPDATE CHAT LIST
       */
      setChatList((prev) => {
        if (!Array.isArray(prev)) return prev;

        return prev.map((chat) => {
          if (String(chat.conversation_mstr_key) === String(data.in_conversation_mstr_key)) {
            return {
              ...chat,
              last_message: data.in_message_text,
              sent_at: new Date().toISOString(),
            };
          }

          return chat;
        });
      });
    };

    socket.on("MESSAGE_SENT", onReceiveMessage);

    const onUnreadMessage = (data) => {
      const isCurrentChat = String(data.in_conversation_mstr_key) === String(selectedChat?.conversation_mstr_key);
      const unread = data?.row_result?.[0]?.total_unread_count || 0;
      if (isCurrentChat) return;
      dispatch(changeMessageCount(unread));

      setChatList((prev) =>
        prev.map((chat) => {
          if (String(chat.conversation_mstr_key) === String(data.in_conversation_mstr_key)) {
            return {
              ...chat,
              unread_count: (chat.unread_count || 0) + 1,
            };
          }
          return chat;
        })
      );
    };

    socket.on("UNREAD_MESSAGE", onUnreadMessage);

    return () => {
      socket.off("connect", registerUserRoom);
      socket.off("MESSAGE_SENT", onReceiveMessage);
      socket.off("UNREAD_MESSAGE", onUnreadMessage);
    };
  }, [socket, selectedChat]);

  useEffect(() => {
    activeChatRef.current = selectedChat;
  }, [selectedChat]);

  useEffect(() => {
    if (!selectedChat) return;

    const scrollToBottom = () => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "auto" });
      }
    };

    const timeout = setTimeout(scrollToBottom, 100);

    return () => clearTimeout(timeout);
  }, [selectedChat]);

  useEffect(() => {
    const container = messagesContainerRef.current;
    if (!container) return;

    // Always scroll to bottom on initial load for a conversation
    if (isInitialMessagesLoadRef.current && allMessages.length > 0) {
      isInitialMessagesLoadRef.current = false;
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "auto" });
      }, 100);
      return;
    }

    // For subsequent updates, only scroll if near bottom
    const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 150;

    if (isNearBottom) {
      const timeout = setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "auto" });
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [allMessages]);

  useEffect(() => {
    if (!userStatusData || userStatusData.length === 0) {
      setIsLoading(true);
    } else {
      fetchChatList();
      getMobileConfig();
    }
  }, [userStatusData]);

  useEffect(() => {
    if (!selectedChat?.conversation_mstr_key) return;
    // const isSearching = search && search.trim().length > 0

    // Reset initial load flag when conversation changes
    isInitialMessagesLoadRef.current = true;

    setIsLoadChat(true);
    // if (!isSearching) {
    setIsLoadStatus(true);
    // }

    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false;
    }

    setAllMessages([]);

    getAllMessages(true).finally(() => {
      setIsLoadChat(false);
      setIsLoadStatus(false);
    });
  }, [selectedChat?.conversation_mstr_key]);

  // useEffect(() => {
  //     if (!chatList || chatList.length === 0) {
  //         setFilteredChatList([])
  //         setSelectedChat(null)
  //         return
  //     }

  //     const uniqueChatList = Array.from(new Map(chatList.map((c) => [c.conversation_mstr_key, c])).values())

  //     let filtered = [...uniqueChatList]

  //     if (selectedTab?.value && selectedTab.value !== 'ALL') {
  //         filtered = filtered.filter((c) => c?.conversation_status?.toUpperCase() === selectedTab.value)
  //     }

  //     const searchTerm = search.trim().toLowerCase()
  //     if (searchTerm) {
  //         filtered = filtered.filter((c) =>
  //             [c?.user_name ?? '', c?.query_type ?? ''].some((f) => f.toLowerCase().includes(searchTerm))
  //         )
  //     }

  //     setFilteredChatList((prev) => {
  //         const sameLength = prev.length === filtered.length
  //         const sameKeys =
  //             sameLength && prev.every((p, i) => p.conversation_mstr_key === filtered[i].conversation_mstr_key)
  //         if (sameKeys) return prev
  //         return filtered.map((f) => ({ ...f }))
  //     })

  //     setSelectedChat((prev) => {
  //         if (isTabSwitchRef.current) {
  //             isTabSwitchRef.current = false

  //             return filtered.length > 0 ? filtered[0] : null
  //         }

  //         if (!prev) return filtered.length > 0 ? filtered[0] : null

  //         const stillExists = filtered.some((f) => f.conversation_mstr_key === prev.conversation_mstr_key)

  //         if (stillExists) {
  //             return filtered.find((f) => f.conversation_mstr_key === prev.conversation_mstr_key)
  //         }

  //         return filtered.length > 0 ? filtered[0] : null
  //     })

  // }, [chatList, selectedTab?.value, search])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim().toLowerCase());
    }, 700);

    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    if (!chatList || chatList.length === 0) {
      setFilteredChatList([]);
      setSelectedChat(null);
      return;
    }

    const uniqueChatList = Array.from(new Map(chatList.map((c) => [c.conversation_mstr_key, c])).values());

    let filtered = [...uniqueChatList];

    if (selectedTab?.value && selectedTab.value !== "ALL") {
      filtered = filtered.filter((c) => c?.conversation_status?.toUpperCase() === selectedTab.value);
    }

    const searchTerm = debouncedSearch;
    if (searchTerm) {
      filtered = filtered.filter((c) =>
        [c?.user_name ?? "", c?.query_type ?? ""].some((f) => f.toLowerCase().includes(searchTerm))
      );
    }

    setFilteredChatList((prev) => {
      const sameLength = prev.length === filtered.length;
      const sameKeys =
        sameLength && prev.every((p, i) => p.conversation_mstr_key === filtered[i].conversation_mstr_key);

      if (sameKeys) return prev;
      // return filtered.map((f) => ({ ...f }));
      return filtered;
    });

    setSelectedChat((prev) => {
      // Preserve direct access selection
      const queryParams = getQueryParams();
      if (queryParams.conversationId && prev?.conversation_mstr_key === parseInt(queryParams.conversationId)) {
        const stillExists = filtered.some((f) => f.conversation_mstr_key === prev.conversation_mstr_key);
        // if (stillExists) {
        //   return filtered.find((f) => f.conversation_mstr_key === prev.conversation_mstr_key);
        // }
        if (stillExists) {
          const updatedChat = filtered.find((f) => f.conversation_mstr_key === prev.conversation_mstr_key);

          if (
            prev &&
            updatedChat &&
            prev.conversation_mstr_key === updatedChat.conversation_mstr_key &&
            prev.unread_count === updatedChat.unread_count &&
            prev.last_message === updatedChat.last_message &&
            prev.conversation_status === updatedChat.conversation_status
          ) {
            return prev;
          }

          return updatedChat;
        }
      }

      if (isTabSwitchRef.current) {
        isTabSwitchRef.current = false;
        return null;
      }

      if (!prev) return null;

      const stillExists = filtered.some((f) => f.conversation_mstr_key === prev.conversation_mstr_key);

      if (stillExists) {
        return filtered.find((f) => f.conversation_mstr_key === prev.conversation_mstr_key);
      }

      return null;
    });
  }, [chatList, selectedTab?.value, debouncedSearch]);

  useEffect(() => {
    if (search.trim() === "" && filteredChatList.length > 0 && skipNextFetchRef.current === false) {
      // Don't override direct access selection when search is cleared
      const queryParams = getQueryParams();
      if (queryParams.conversationId) {
        const targetInList = filteredChatList.find(
          (chat) => String(chat.conversation_mstr_key) === String(queryParams.conversationId)
        );
        if (targetInList) {
          return;
        }
      }
      // Keep no chat selected after search is cleared
    }
  }, [search, filteredChatList]);

  return (
    <div className="Main dashboard">
      <div className="content">
        <div className="content-head">
          <HeaderPage pageProps={pageProps} headerConfig={headerConfig} />
        </div>
        <div className="content-body messages-section">
          <div
            className="messages-container"
            style={{
              opacity: isLoadStatus ? 0.4 : 1,
              pointerEvents: isLoadStatus ? "none" : "auto",
            }}
          >
            {isLoadStatus && (
              <div className="loader-overlay">
                <LoadingPanel gridId="pay-request-tracker-grid" />
              </div>
            )}

            <div className="messages-left-panel">
              <div className="left-content">
                <div className="status-container">
                  {statusTabs.map((tab) => {
                    const getCounts = () => ({
                      ALL: chatList.length,
                      PENDING: chatList.filter((c) => c.conversation_status === "PENDING").length,
                      RESOLVED: chatList.filter((c) => c.conversation_status === "RESOLVED").length,
                    });
                    const counts = getCounts();
                    return (
                      <div
                        key={tab.id}
                        className="status-item"
                        style={{
                          backgroundColor: selectedTab?.id === tab.id ? "rgba(0, 161, 228, 0.2)" : "transparent",
                          color: selectedTab?.id === tab.id ? "#00A1E4" : "#6B6C6D",
                        }}
                        onClick={() => handleTabSelect(tab)}
                      >
                        <div className="status-label">{tab.label}</div>
                        {/* {isLoading ? (
                          <Loader size="small" className="k-loading-procare" />
                        ) : (
                          <div className="status-count">{counts[tab.value]}</div>
                        )} */}
                      </div>
                    );
                  })}
                </div>

                <div className="flex-row">
                  <div className="search-wrapper">
                    <img
                      src={require("../../images/search-icon.png").default}
                      alt="Search Icon"
                      className="search-icon"
                    />
                    <Input
                      autoComplete="off"
                      type="text"
                      name="search"
                      placeholder="Search"
                      value={search}
                      className="search-input"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  <div>
                    {/* <span className="msg-btn" onClick={() => setVisible(true)}>
                      <i className="fas fa-comment-dots" style={{ color: "white" }}></i>
                      <div className="msg-btn-text">NEW MESSAGE</div>
                    </span> */}
                    <Button icon="plus" onClick={() => setVisible(true)} className="button-primary" title="NEW MESSAGE">
                      NEW MESSAGE
                    </Button>
                  </div>
                </div>

                <div className="messages-container" ref={chatListContainerRef}>
                  {
                    isLoading ? (
                      <Loader size="large" className="k-loading-procare" />
                    ) : filteredChatList?.length > 0 ? (
                      <>
                        {filteredChatList.map((msg) => (
                          <div
                            key={msg?.conversation_mstr_key}
                            ref={
                              selectedChat?.conversation_mstr_key === msg?.conversation_mstr_key
                                ? selectedChatRef
                                : null
                            }
                            className={`message-card ${
                              selectedChat?.conversation_mstr_key === msg?.conversation_mstr_key ? "highlight" : ""
                            }`}
                            onClick={() => onSelectChat(msg)}
                          >
                            <div className="message-avatar">
                              <i className="far fa-user"></i>
                            </div>
                            <div className="message-content">
                              <div className="message-name">{msg?.user_name}</div>
                              <div className="message-topic">{msg?.query_type}</div>
                              {msg?.last_message && msg?.last_name !== "" ? (
                                <div className="message-text">{msg?.last_message}</div>
                              ) : (
                                <div className="message-text">{msg?.original_name}</div>
                              )}
                              <span className="message-time" style={{ color: "#6b6c6d" }}>
                                {moment
                                  .tz(msg.sent_at, "America/New_York") // server time zone is America/New_York
                                  .clone()
                                  .tz(moment.tz.guess())
                                  .format("MM/DD/YYYY, hh:mm A")}
                              </span>
                            </div>
                            <div className="message-footer">
                              <div
                                className={`message-status ${
                                  msg?.conversation_status === "RESOLVED" ? "RESOLVED" : "PENDING"
                                }`}
                              >
                                {msg.conversation_status &&
                                  msg.conversation_status.charAt(0).toUpperCase() +
                                    msg.conversation_status.slice(1).toLowerCase()}
                              </div>
                              {msg?.conversation_status !== "RESOLVED" && msg?.unread_count > 0 && (
                                <div className="message-count">{msg?.unread_count}</div>
                              )}
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      // !isLoading &&
                      // filteredChatList?.length === 0 && (
                      <div className="no-data-text" style={{ color: "#6b6c6d" }}>
                        No Data found
                      </div>
                      // )
                    )
                    // )
                  }
                </div>
              </div>
            </div>
            <div className="messages-right-panel">
              <div className="right-content">
                <div className="chat-card">
                  {isLoading ? (
                    <Loader size="large" className="k-loading-procare" />
                  ) : (
                    <div className="chat-left">
                      {selectedChat?.user_name && (
                        <div className="avatar">
                          <i className="far fa-user"></i>
                        </div>
                      )}
                      <div className="chat-info">
                        {selectedChat?.user_name && <div className="chat-name">{selectedChat?.user_name}</div>}
                        <div className="chat-topic">{selectedChat?.query_type}</div>
                        {selectedChat?.specialty_name && (
                          <div className="chat-subtext">{selectedChat?.specialty_name}</div>
                        )}
                      </div>
                    </div>
                  )}
                  {selectedChat != null && (
                    <div>
                      {userStatusData?.[0]?.pay_request_tracker_read_access === 1
                        ? selectedChat?.conversation_status != "RESOLVED" && (
                            <span
                              className="resolve-btn"
                              style={{ borderRadius: "10px" }}
                              onClick={() => {
                                setResolvedKey(selectedChat.conversation_mstr_key);
                                setIsVisibleConfirmation(true);
                              }}
                            >
                              {/* <img src={require("../../images/resolved-icon.png").default} alt="Resolved Icon" /> */}
                              <span>Mark Resolved</span>
                            </span>
                          )
                        : selectedChat?.conversation_status && (
                            <div
                              className={`message-status ${
                                selectedChat?.conversation_status === "RESOLVED" ? "resolved" : "PENDING"
                              }`}
                            >
                              {selectedChat?.conversation_status &&
                                selectedChat?.conversation_status.charAt(0).toUpperCase() +
                                  selectedChat?.conversation_status.slice(1).toLowerCase()}
                            </div>
                          )}
                    </div>
                  )}
                </div>

                <div className="chat-wrapper">
                  <div className="chat-messages" ref={messagesContainerRef}>
                    {isLoadChat ? (
                      <div className="chat-loader-wrapper">
                        <Loader size="large" className="k-loading-procare" />
                      </div>
                    ) : selectedChat ? (
                      <>
                        <div className="chat-spacer" />
                        {allMessages.map((msg) => {
                          const isOutgoing = String(msg?.sender_id) === String(cookiesData?.out_user_id);
                          const hasText = msg?.message_text && msg?.message_text.trim() !== "";
                          const hasDocs = Array.isArray(msg?.documents) && msg?.documents.length > 0;

                          return hasText || hasDocs ? (
                            <>
                              <div className={`chat-sender-wrapper ${isOutgoing ? "outgoing" : "incoming"}`}>
                                {!isOutgoing && (
                                  <div className="message-avatar-chat">
                                    <i className="far fa-user"></i>
                                  </div>
                                )}

                                <div className="chat-sender" style={{ color: isOutgoing ? "#00A1E4" : "#737373" }}>
                                  {isOutgoing ? "You" : msg?.sender_name}
                                </div>
                              </div>
                              <div
                                key={msg.message_mstr_key || msg.id}
                                className={`chat-message ${isOutgoing ? "outgoing" : "incoming"}`}
                              >
                                <div className="chat-bubble">
                                  {hasText && (
                                    <div className="chat-text" style={{ whiteSpace: "pre-wrap", color: "#6b6c6d" }}>
                                      {msg.message_text}
                                    </div>
                                  )}
                                  {hasDocs &&
                                    msg?.documents.map((doc) => (
                                      <div key={doc?.original_name} className="chat-text">
                                        <div className="flex-row-icon">
                                          {doc?.original_name}
                                          <div style={{ cursor: "pointer" }} onClick={() => handleFileDownload(doc)}>
                                            <i className="fas fa-download"></i>
                                          </div>
                                        </div>

                                        {msg.sender_id === cookiesData?.out_user_id &&
                                          fileProgress[doc?.original_name] !== undefined && (
                                            <span className="upload-progress">
                                              {fileProgress[doc.original_name] < 100
                                                ? `${fileProgress[doc.original_name]}%`
                                                : ""}
                                            </span>
                                          )}
                                      </div>
                                    ))}
                                </div>
                              </div>
                              <div
                                className="chat-time"
                                style={{
                                  display: "flex",
                                  justifyContent: isOutgoing ? "flex-end" : "flex-start",
                                  alignItems: "center",
                                  gap: "4px",
                                  color: "#6b6c6d",
                                  marginLeft: "2rem",
                                }}
                              >
                                <span>
                                  {moment
                                    .tz(msg.sent_at, "America/New_York")
                                    .clone()
                                    .tz(moment.tz.guess())
                                    .format("MM/DD/YYYY, hh:mm A")}
                                </span>

                                {isOutgoing &&
                                  (msg?.is_seen == 1 ? (
                                    <i className="fas fa-check-double" style={{ color: "#008dcc" }} />
                                  ) : (
                                    <i className="fas fa-check" />
                                  ))}
                              </div>
                            </>
                          ) : (
                            <></>
                          );
                        })}

                        {allMessages?.length === 0 && !isLoading && <div className="no-data-text">No Chat found</div>}
                      </>
                    ) : (
                      <div className="welcome-state">
                        <div className="welcome-message-icon">
                          <i className="fas fa-comment-alt"></i>
                        </div>
                        <h2 className="welcome-title">Welcome to Your Conversations</h2>
                        <p className="welcome-subtitle">
                          Select a chat from the list to start exploring your messages or begin a new conversation
                        </p>
                      </div>
                    )}
                    <div ref={messagesEndRef} />
                  </div>

                  {selectedChat != null && (
                    <div className="chat-input-container">
                      <div className="input-wrapper">
                        {selectedDoc?.length > 0 && (
                          <div className="document-container">
                            {selectedDoc.map((doc) => (
                              <div key={doc.original_name} className="document-item">
                                <span className="document-name">{doc.original_name}</span>
                                <span className="document-close">
                                  <img
                                    src={require("../../images/close-icon.png").default}
                                    alt="close"
                                    height={8}
                                    width={8}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setSelectedDoc((prev) =>
                                        prev.filter((d) => d.original_name !== doc.original_name)
                                      )
                                    }
                                  />
                                </span>
                              </div>
                            ))}
                          </div>
                        )}

                        {selectedChat?.conversation_status != "RESOLVED" && (
                          <>
                            <div className="input-wrapper">
                              <TextArea
                                className="chat-input"
                                placeholder="Type Your Message..."
                                rows={4}
                                name="message"
                                value={inputText}
                                onChange={(e) => setInputText(e.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage();
                                  }
                                }}
                                style={{ resize: "none", border: "1px solid #E5E5E5 " }}
                              />

                              <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                multiple
                                onChange={handleFileChange}
                                max={5}
                              />

                              <img
                                src={require("../../images/attachment-icon.png").default}
                                alt="attach"
                                className="input-icon"
                                onClick={handleAttachClick}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      {selectedChat?.conversation_status !== "RESOLVED" && (
                        <span
                          className={`chat-send-btn ${!inputText?.trim() && selectedDoc?.length === 0 ? "disabled" : ""}`}
                          onClick={() => {
                            if (inputText.trim() || selectedDoc.length !== 0) handleSendMessage();
                          }}
                        >
                          <span className="send-text">Send</span>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {visible && (
        <NewMessage
          visible={visible}
          onClose={() => setVisible(false)}
          onChatCreated={() => fetchChatList()}
          isLoadStatus={isLoading}
          setIsLoadStatus={setIsLoading}
          isLoadChat={isLoadChat}
          setIsLoadChat={setIsLoadChat}
          setAllMessages={setAllMessages}
          setSelectedTab={setSelectedTab}
          statusTabs={statusTabs}
          messagesEndRef={messagesEndRef}
        />
      )}

      {isVisibleCofirmation && (
        <Window
          title="Confirm"
          width={500}
          resizable={false}
          stage={stageChange}
          onStageChange={handleStageChange}
          modal={modal}
          top={200}
          className="auto-height-window"
          onClose={() => setIsVisibleConfirmation(false)}
        >
          <div className="window-container">
            <div className="confirm-label">Are you sure you want to mark this as resolved?</div>

            <div className="window-btn-container">
              <button onClick={() => setIsVisibleConfirmation(false)} className="window-cancel-btn">
                Cancel
              </button>
              <span
                className="window-send-btn"
                onClick={() => {
                  setIsLoadStatus(true);
                  handleChangeStatus();
                  setIsVisibleConfirmation(false);
                }}
              >
                <span className="window-send-text">Yes</span>
              </span>
            </div>
          </div>
        </Window>
      )}
    </div>
  );
};

export default React.memo(Messages);